import { render } from "./button.vue?vue&type=template&id=7d08310c&scoped=true&ts=true"
import script from "./button.vue?vue&type=script&lang=ts"
export * from "./button.vue?vue&type=script&lang=ts"

import "./button.vue?vue&type=style&index=0&id=7d08310c&lang=scss&scoped=true"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d08310c"]])

export default __exports__